// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"50f27290","455":"c8ee3851","977":"cc7e919b"}[chunkId] + ".chunk.js";
};